import { Action } from '@ngrx/store';
import { IMegaMenu, IMouGallery } from './shared.state';

export enum WebsiteSharedActionTypes {
    FETCH_MEGA_MENU = '[takeoff-website-projects] FETCH_MEGA_MENU',
    FETCH_MEGA_MENU_SUCCESS = '[takeoff-website-projects] FETCH_MEGA_MENU_SUCCESS',
    FETCH_MEGA_MENU_FAIL = '[takeoff-website-projects] FETCH_MEGA_MENU_FAIL',
    FETCH_MOU_GALLERY_DETAILS = '[takeoff-website-projects] FETCH_MOU_GALLERY_DETAILS',
    FETCH_MOU_GALLERY_DETAILS_SUCCESS = '[takeoff-website-projects] FETCH_MOU_GALLERY_DETAILS_SUCCESS',
    FETCH_MOU_GALLERY_DETAILS_FAIL = '[takeoff-website-projects] FETCH_MOU_GALLERY_DETAILS_FAIL',
    FETCH_MOU_GALLERY = '[takeoff-website-projects] FETCH_MOU_GALLERY',
    FETCH_MOU_GALLERY_SUCCESS = '[takeoff-website-projects] FETCH_MOU_GALLERY_SUCCESS',
    FETCH_MOU_GALLERY_FAIL = '[takeoff-website-projects] FETCH_MOU_GALLERY_FAIL'
};

export class FETCH_MEGA_MENU implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MEGA_MENU;
}

export class FETCH_MEGA_MENU_SUCCESS implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MEGA_MENU_SUCCESS;

    constructor(public payload: IMegaMenu) { }
}

export class FETCH_MEGA_MENU_FAIL implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MEGA_MENU_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_MOU_GALLERY implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY;

    constructor(public payload?: any) { }
}

export class FETCH_MOU_GALLERY_SUCCESS implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY_SUCCESS;

    constructor(public payload: IMouGallery[]) { }
}

export class FETCH_MOU_GALLERY_FAIL implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY_FAIL;

    constructor(public payload: any) { }
}

export class FETCH_MOU_GALLERY_DETAILS implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS;

    constructor(public payload?: any) { }
}

export class FETCH_MOU_GALLERY_DETAILS_SUCCESS implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS_SUCCESS;

    constructor(public payload: IMouGallery[]) { }
}

export class FETCH_MOU_GALLERY_DETAILS_FAIL implements Action {
    readonly type = WebsiteSharedActionTypes.FETCH_MOU_GALLERY_DETAILS_FAIL;

    constructor(public payload: any) { }
}

export type WebsiteSharedActions = | FETCH_MEGA_MENU
    | FETCH_MEGA_MENU_SUCCESS
    | FETCH_MEGA_MENU_FAIL
    | FETCH_MOU_GALLERY
    | FETCH_MOU_GALLERY_SUCCESS
    | FETCH_MOU_GALLERY_FAIL
    | FETCH_MOU_GALLERY_DETAILS
    | FETCH_MOU_GALLERY_DETAILS_SUCCESS
    | FETCH_MOU_GALLERY_DETAILS_FAIL;